// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
import "../scss/style.scss";

// Footer "Cookie Policy" link -> Cookiebot consent settings.
// Keep this static and outside the Divi-builder branch: the footer is shared
// Theme Builder content and may be rendered after this entry module runs.
import "./cookie-consent.js";

// ── Assessment-tool click guard ────────────────────────────────
// Divi renders every Button module as `<a class="et_pb_button" href="">`, and an
// empty href RELOADS the page on click. `hcp-assessment-tool.js` prevents that
// on every control it owns — but it is a DYNAMIC import fired from
// DOMContentLoaded, so the handler is two network hops from the markup it
// protects. Measured on ?page_id=4212: the intro is painted from ~0.6s, THIS
// file is not downloaded yet at 1036ms, and the tool chunk is not even
// REQUESTED until ~3400ms. A tap in that window navigates to "" and the tool
// resets — the reported "sometimes it just refreshes".
//
// The guard that actually closes that window is printed INLINE in the document
// head (tfn_print_hcp_click_guard in functions.php) — it has nothing to
// download, so it is listening before the tool's markup even exists. This file
// only owns the HANDOFF: flip `ready` and replay the parked press once the tool
// has wired itself.
//
// The listener is re-installed here only if the inline guard is missing (an
// HTML response cached from before it shipped), so there is never more than one
// listener and never a double replay.
const HCP_TOOL_SELECTOR = ".et_pb_section.hcp-assessment-tool a";

const hcpGuard = (window.__tfnHcpGuard = window.__tfnHcpGuard || {
  ready: false,
  pending: null,
});

if (!hcpGuard.installed) {
  hcpGuard.installed = true;

  document.addEventListener(
    "click",
    (event) => {
      if (hcpGuard.ready) return;

      const target = event.target;
      const link =
        target && target.closest ? target.closest(HCP_TOOL_SELECTOR) : null;
      if (!link) return;

      const href = link.getAttribute("href");
      if (href && href !== "#") return;

      event.preventDefault();
      hcpGuard.pending = link;
    },
    true,
  );
}

/**
 * Hand control back to the tool and replay whatever was pressed early.
 *
 * The chunk self-initialises on import, but only once the DOM is ready — so if
 * it ever lands before DOMContentLoaded this has to wait too, or the replayed
 * click would hit a section that is not wired yet AND the guard would already
 * be off. The tool registers its own DOMContentLoaded listener during module
 * evaluation, which is before this one, so it still wires first.
 * @returns {void}
 */
const releaseHcpTool = () => {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", releaseHcpTool, {
      once: true,
    });
    return;
  }

  hcpGuard.ready = true;

  const pending = hcpGuard.pending;
  hcpGuard.pending = null;
  if (pending && pending.isConnected) pending.click();
};

// Divi replaces this offscreen image's desktop src/srcset with its phone
// variants at runtime. While doing so it adds `et_multi_view_image__loading`,
// which hides the image until a load event fires. Mobile Safari can leave the
// dynamically-swapped image in its native lazy state indefinitely, so the
// image remains hidden until a refresh. Make the final responsive source eager
// after Divi finishes its synchronous attribute updates.
const HOME_FAMILY_IMAGE_SELECTOR =
  'body.page-hcp img[title="hcp-home-page-card-luiz-mobile"]';

const forceHomeFamilyImageLoad = (image) => {
  image.loading = "eager";
  image.removeAttribute("decoding");
};

window.addEventListener("divi:multiView:setAttrs", (event) => {
  const image = event.detail?.item?.element;
  const updatedData = event.detail?.updatedData ?? {};

  if (
    image instanceof HTMLImageElement &&
    image.matches(HOME_FAMILY_IMAGE_SELECTOR) &&
    Object.prototype.hasOwnProperty.call(updatedData, "src")
  ) {
    queueMicrotask(() => forceHomeFamilyImageLoad(image));
  }
});

document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("load", () => {
    document.body.classList.add("loaded");

    // Fallback for cached pages or a different Divi initialization order.
    const homeFamilyImage = document.querySelector(
      HOME_FAMILY_IMAGE_SELECTOR,
    );
    if (homeFamilyImage instanceof HTMLImageElement) {
      forceHomeFamilyImageLoad(homeFamilyImage);
    }
  });
  let canScrollToTopOnResize = false;

  let insideDiviBuilder =
    window.top?.et_builder_utils_params?.builderType === "vb"; //fe for non builder mode

  // Only load ISI script if not in Divi Visual Builder
  if (!insideDiviBuilder) {
    console.log("✅ Not inside Divi Visual Builder");
    import("./isi.js")
      .then(() => {
        console.log("ISI script loaded");
      })
      .catch((err) => {
        console.warn("Failed to load ISI script:", err);
      });

    import("../scss/components/header/header.js")
      .then(() => {
        console.log("Header script loaded");
      })
      .catch((err) => {
        console.warn("Failed to load Header script:", err);
      });

    import("./modal.js")
      .then(() => {
        console.log("Modal script loaded");
      })
      .catch((err) => {
        console.warn("Failed to load Modal script:", err);
      });
    import("./tooltip.js")
      .then(() => {
        console.log("Tooltip script loaded");
      })
      .catch((err) => {
        console.warn("Failed to load Tooltip script:", err);
      });

    import("./hcp-assessment-tool.js")
      .then(() => {
        releaseHcpTool();
        console.log("HCP Assessment tool script loaded");
      })
      .catch((err) => {
        console.warn("Failed to load HCP Assessment tool script:", err);
      });

    import("./forms.js")
      .then(() => {
        console.log("Forms script loaded");
      })
      .catch((err) => {
        console.warn("Failed to load Forms script:", err);
      });
  } else {
    console.log("❌ Skipping ISI script, Inside Divi Visual Builder");
  }

  console.log("palsonify theme", "v1.0.0");

  const scrollToTop = () => {
    const iframe = document.getElementById("jd-iframe-form");
    if (!iframe) return;

    const iframeTop = window.scrollY + iframe.getBoundingClientRect().top;
    const scrollTarget = Math.max(iframeTop - 100, 0);

    console.log("[Parent] scrolling iframe into view");
    window.scrollTo({
      top: scrollTarget,
      behavior: "smooth",
    });

    iframe.focus({ preventScroll: true });
  };

  setTimeout(() => {
    canScrollToTopOnResize = true;
  }, 5000);

  window.addEventListener("message", function (event) {
    console.log(
      "[Parent] message received:",
      event.data,
      "from:",
      event.origin,
    );

    if (event.data && event.data.type === "resize") {
      const iframe = document.getElementById("tfn-iframe-form");
      if (iframe) {
        console.log("[Parent] resizing iframe to:", event.data.height + "px");
        iframe.style.height = event.data.height + "px";
        if (canScrollToTopOnResize) {
          scrollToTop();
        }
        // iframe.style.minHeight = event.data.height + "px";
      } else {
        console.warn(
          "[Parent] iframe element not found — check the id matches",
        );
      }
    }

    if (event.data && event.data.type === "success") {
      scrollToTop();
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "cloudpage_form_success",
        form_name: "Salesforce CloudPage form",
        form_id: "salesforce_cloudpage_form",
      });
    }
  });
});
